import { render, staticRenderFns } from "./LinkOrganization.vue?vue&type=template&id=afa3cce8&scoped=true&lang=pug&"
import script from "./LinkOrganization.vue?vue&type=script&lang=js&"
export * from "./LinkOrganization.vue?vue&type=script&lang=js&"
import style0 from "./LinkOrganization.vue?vue&type=style&index=0&id=afa3cce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa3cce8",
  null
  
)

export default component.exports